export default __webpack_public_path__ + "static/media/casapilot_logo.9ed5e24a.png";